/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".notification-modal .modal-dialog{max-width:40.625rem}.notification-modal .modal-content{border-radius:1.5rem;overflow:hidden;border:none}.close-button{position:absolute;top:1.5rem;right:1.5rem;border:none;background:none;z-index:1000;cursor:pointer;color:#fff}lp2-base-notification>.close-button:focus{outline:2px solid #fff;outline-offset:2px}"];
export { styles as styles };
//# sourceMappingURL=base-notification-modal.component.scss.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/shared/base-notification-modal/base-notification-modal.component.scss.ngstyle.js
// module id = 1418
// module chunks = 27 28 29